import React, { useEffect, useState } from "react";
import { Button, InputNumber, message } from "antd";
import TimeShower from "../../../components/TimeShower";
import { removeDataReqService, sendVerifyCodeService } from "../setting.api";
import { signOut } from "../../../actions/profile";
import { useDispatch } from "react-redux";

const Status = {
  agreement: 2,
  verifyCode: 3,
  done: 4,
};
const errorMessage =
  "شما مشاوره در حال انجام و یا در انتظار تمدید دارید. جهت اعمال تغییر در پروفایل خود ابتدا به تمامی مشاوره ها خاتمه دهید.";

function OTPConfirm({ setClose }) {
  const [status, setStatus] = useState(Status.agreement);
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [waitTime, setWaitTime] = useState(0);
  const dispatch = useDispatch();

  function handleConfirm() {
    setLoading(true);
    removeDataReqService()
      .then((r) => {
        setStatus(Status.verifyCode);
        setWaitTime(1000 * 60);
      })
      .catch((e) => {
        setClose();

        if (e.message === "Request failed with status code 412") {
          message.error(errorMessage);
        } else {
          message.error("مشکلی پیش آمده، دباره امتحان کنید.");
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }

  function handleVerifyCode() {
    if (!code || (code && code.length < 2)) {
      return false;
    }

    setLoading(true);
    sendVerifyCodeService(code)
      .then((r) => {
        setClose();
        dispatch(signOut());
        setLoading(false);
      })
      .catch((e) => {
        message.error("کد ارسالی اشتباه بود");
        setLoading(false);
      });
  }

  useEffect(() => {
    let interval;
    if (waitTime > 0) {
      interval = setInterval(() => {
        setWaitTime(waitTime - 1000);
      }, 1000);
    } else if (waitTime < 0) {
      setWaitTime(0);
    }
    return () => {
      clearInterval(interval);
    };
    // eslint-disable-next-line
  }, [waitTime]);

  return (
    <>
      {status === Status.agreement && (
        <>
          <h3 className="title">با انجام این کار اطلاعات شما به طور کامل حذف می شود و امکان بازیابی آن وجود نخواهد داشت. آیا مطمئن هستید؟ </h3>
          <div className="confirm-remove-data center-flex">
            <Button className="submit-form" onClick={setClose}>
              لغو
            </Button>
            <Button className="submit-form" onClick={handleConfirm}>
              تائید
            </Button>
          </div>
        </>
      )}
      {status === Status.verifyCode && (
        <>
          <h3 className="title">
            جهت حذف اطلاعات از لاوین کد فعالسازی پیامک شده را وارد فرمایید
          </h3>
          <InputNumber
            className="text-input"
            value={code}
            onChange={(value) => setCode(value)}
          />
          <div className="timer">
            <span className="timer-title" onClick={handleConfirm}>
              ارسال کد فعال سازی
            </span>
            <span className="timer-value">
              <TimeShower time={waitTime ? waitTime / 1000 : 0} />
            </span>
          </div>
          <Button
            className="submit-form"
            onClick={handleVerifyCode}
            disabled={
              loading ||
              (status === Status.verifyCode &&
                (code === null || code.length < 3))
            }
          >
            ثبت
          </Button>
        </>
      )}
      {status === Status.done && (
        <div className="success-message">
          .تمامی اطلاعات شما با موفقیت از لاوین حذف شد
        </div>
      )}
    </>
  );
}

export default OTPConfirm;
